import { IconName } from "@zenchef/icomoon/dist/aromaticons/types";
import { AromaToastVariant } from "@zenchef/styled-system/recipes";

export enum AromaPlacement {
  TopCenter = "top-center",
  TopLeft = "top-left",
  TopRight = "top-right",
  BottomCenter = "bottom-center",
  BottomLeft = "bottom-left",
  BottomRight = "bottom-right",
}

export const TOAST_ICON = {
  neutral: "placeholder-circle",
  info: "info-circle",
  warning: "alert-circle",
  error: "alert-triangle",
  success: "check-01-circle",
  "ai-success": "phone-sparkles",
} as const satisfies Record<AromaToastVariant["function"], IconName>;

export interface ToastShowOptions {
  title?: string;
  duration?: number;
  iconName?: IconName;
  description?: string;
  placement?: AromaPlacement;
  type?: AromaToastVariant["function"];
  action?: {
    label: string;
    onClick: () => void;
  };
}
